import React, { useState, useRef, useEffect } from "react";
import { Minus, Plus } from "lucide-react";

const Stepper = ({ value: propValue = 0, onChange, min = 0, max = 100 }) => {
  // Estado para controlar si estamos en proceso de actualización
  const [isUpdating, setIsUpdating] = useState(false);
  // Referencia para almacenar el último valor conocido
  const lastKnownValueRef = useRef(propValue);
  
  // Actualizamos la referencia cuando propValue cambia
  useEffect(() => {
    lastKnownValueRef.current = propValue;
    // Si estábamos actualizando, ahora ya no lo estamos
    setIsUpdating(false);
  }, [propValue]);
  
  // Aseguramos que el valor esté dentro de los límites
  const safeValue = Math.max(min, Math.min(max, propValue));
  
  const handleIncrement = () => {
    // Si ya estamos actualizando, no hacemos nada
    if (isUpdating) return;
    
    if (safeValue < max) {
      // Marcamos que estamos actualizando
      setIsUpdating(true);
      // Notificamos al padre
      onChange(safeValue + 1);
    }
  };

  const handleDecrement = () => {
    // Si ya estamos actualizando, no hacemos nada
    if (isUpdating) return;
    
    if (safeValue > min) {
      // Marcamos que estamos actualizando
      setIsUpdating(true);
      // Notificamos al padre
      onChange(safeValue - 1);
    }
  };

  // Si el valor es 0, mostrar un único botón de Agregar
  if (safeValue === 0) {
    return (
      <div className="w-full h-10 max-h-[40px] bg-blue-600 rounded-lg overflow-hidden text-blue-50 font-medium flex justify-center items-center">
        <button
          onClick={handleIncrement}
          className="w-full h-full flex items-center justify-center border-0 text-blue-50"
          disabled={isUpdating}
        >
          <Plus size={18} className="mr-1" />
          <span>Agregar</span>
        </button>
      </div>
    );
  }

  // Vista normal para valores mayores a 0
  return (
    <div className="w-full h-10 max-h-[40px] bg-blue-100 rounded-md text-blue-500 font-medium flex justify-between items-center px-2">
      <button
        onClick={handleDecrement}
        className={`w-8 h-8 flex items-center justify-center bg-transparent border-0 text-blue-500 ${
          isUpdating ? "opacity-50" : "hover:bg-blue-200 active:bg-blue-300 hover:rounded-lg"
        }`}
        disabled={isUpdating}
      >
        <Minus size={20} />
      </button>
      
      <div className="w-8 flex justify-center items-center text-xl text-blue-600">
        {safeValue}
      </div>
      
      <button
        onClick={handleIncrement}
        className={`w-8 h-8 flex items-center justify-center bg-transparent border-0 text-blue-500 ${
          safeValue >= max || isUpdating ? "opacity-50" : "hover:bg-blue-200 active:bg-blue-300 hover:rounded-lg"
        }`}
        disabled={safeValue >= max || isUpdating}
      >
        <Plus size={20} />
      </button>
    </div>
  );
};

export default Stepper;